import $ from 'jquery'
import block from '../assets/BlockUI/jquery.blockUI'
import toastr from 'toastr'
import BackendApi from '../backendApi'



export default {
    blockUI: function (target, message, opts) {
        let options = {
            message: `<div class="loading-message loading-message-boxed"><span>&nbsp;&nbsp;${message}</span></div>`,
            overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.1 }
        };
        if(opts){
            options = Object.assign(options, opts);
        }
        $(target).block(options);
    },

    unblockUI: function (target) {
        $(target).unblock();
    },

    toastr: {
        error: function (text){
            toastr.error(text);
        },

        success: function (text) {
            toastr.success(text);
        }
    },

    /**
     * форматирует ссылки из текста при отображении в кликабельный url
     * формат текста [название](ссылка) позволяет задать имя ссылке
     * @param val
     * @returns {*}
     */
    format_text_to_url: function (val) {
        let total = val;
        let urlRegexWithName = /\[(.+?)\]\(<a(.+?)a>\)/g;
        let urlRegex = /(https?:\/\/[^\s]+)/g;
        let urlInHref = /(href="(.+?)")/g;
        total = total.replace(urlRegex, function (url) {
            let lastSimbol = '';
            if (url.lastIndexOf(')') > -1) {
                lastSimbol = ')';
                url = url.replace(')', '');
            }
            return '<a class="view-link" href="' + url + '" target="_blank" title="' + url + '">' + url + '</a>' + lastSimbol;
        });
        total = total.replace(urlRegexWithName, function (url) {
            let href_url = url.match(urlInHref)[0];
            href_url = href_url.substring(6, href_url.length - 1);
            return '<a class="view-link" href="' + href_url + '" target="_blank" title="' + href_url + '">' + url.substring(url.indexOf('[') + 1, url.indexOf('](')) + '</a>';
        });
        return total;
    },
    //для форматирования текста 
    format_text_helper: function (val) {
        let n = 0;
        let spliter = val.split('**');
        if (spliter.length > 1) {
            val = "";
            while (n < spliter.length - 1) {
                val = val + spliter[n] + (n % 2 === 0 ? '<strong>' : '</strong>');
                n++;
            }
            val = val + spliter[n];
            n = 0;
        }
        return val;
    },
    //сворачивание-разворачивание блоков
    block_collapse: function (e) {
        var $base = $(e).parent();
        if ($base.hasClass('closed')) {
            $base.removeClass('closed').addClass('opened');
        } else {
            $base.removeClass('opened').addClass('closed');
        }
    },

    pdf_view: function (url) {
        return '<div class="pdf-view"><object data="' + url + '" type="application/pdf" width="100%" height="100%">' +
            '<p>Браузер не поддерживает просмотр PDF. <a href="' + url + '" target="_blanc">Нажмите здесь, чтобы скачать</a>.</p>' +
            '</object>' + 
            '<a class="pdf-view-mob" href="' + url + '" target="_blanc">Нажмите, чтобы скачать презентацию</a>' + 
            '</div>';
    },

    project_colors: function (id) {
        let color = "";
        switch (id) {
            case 1: color = "rgb(85, 202, 222)"; break;
            case 2: color = "rgb(236, 126, 1)"; break;
            case 6: color = "rgb(17, 175, 223)"; break;
            case 9: color = "rgb(236, 126, 1)"; break;
            case 15: color = "rgb(15, 89, 212)"; break;
            case 16: color = "rgb(101, 141, 27)"; break;
            case 18: color = "rgb(238, 102, 0)"; break;
            case 19: color = "rgb(0, 173, 239)"; break;
            case 22: color = "rgb(77, 77, 77)"; break;
            case 26: color = "rgb(255, 0, 0)"; break;
            case 28: color = "rgb(244, 158, 178)"; break;
            case 31: color = "rgb(137, 214, 31)"; break;
            case 32: color = "rgb(0, 146, 216)"; break;
            default: color = "rgb(13, 119, 233)";
        }
        return color;
    },


    blockTillDownloaded: function(guid, element, delay){
        let that = this;

        this.blockUI(element);
        let backendApi = new BackendApi();
        let interval = setInterval(function () {
            backendApi.checkDownloaded(guid)
                .then(function (resp) {
                    if (resp.hasError || resp.data.exists === false) {
                        that.unblockUI(element);
                        clearInterval(interval);
                    }
                })
        }, (delay || 1000));
    },

    check_mobile: function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    },

    downloadFileByBytes: function (data, filename, typein) {
        let binaryString = window.atob(data);
        let binaryLen = binaryString.length;
        let bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        let blob = new Blob([bytes], { type: typein });
        let urlStr = URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = urlStr;
        link.download = filename;
        link.click();
        link.remove();
        URL.revokeObjectURL(urlStr);
    }
}


// WEBPACK FOOTER //
// ./Content/src/helpers/ui-helpers.js